import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import TextInput from '../../shared/TextInput'
import DropdownField from '../../shared/DropdownField'
import CustomButton from '../../shared/CustomButton'
import DatePicker from '../../shared/DatePicker'
import ReusableModal from '../../shared/ReuseableModal'
import BulkSubmitClaimsModal from '../../components/his/claimgeneration/BulkSubmitClaimsModal'
import { FiSend } from 'react-icons/fi'

function ClaimListFilters({
  payloadData,
  setPayloadData,
  fetchNewData,
  loading,
  showBulkSubmit = true
}) {
  const { t } = useTranslation()

  const [showBulkSubmitModal, setShowBulkSubmitModal] = useState(false)

  const handleChange = event => {
    const { name, value } = event.target || {}
    setPayloadData(prevValues => ({
      ...prevValues,
      [name]: moment(value).format('YYYY-MM-DD')
    }))
  }

  const handleTypeChange = e => {
    setPayloadData({
      ...payloadData,
      payer_id: e.target?.value
    })
  }

  const handleApplyFilters = () => {
    let payload = {
      ...payloadData,
      page: 1,
      perPage: 20
    }
    fetchNewData(payload)
    setPayloadData(payload)
  }

  const handleResetFilters = () => {
    let payload = {
      ...payloadData,
      page: 1,
      perPage: 20,
      patient_file_number: '',
      document_id: '',
      start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD')
    }
    fetchNewData(payload)
    setPayloadData(payload)
  }

  const handleBulkSubmit = () => {
    setShowBulkSubmitModal(true)
  }

  return (
    <>
    <div className='flex flex-wrap gap-2 mb-2'>
      <div className='w-[200px]'>
        <DatePicker
          name='start_date'
          value={
            payloadData?.start_date
              ? moment(payloadData?.start_date, 'YYYY-MM-DD').toDate()
              : ''
          }
          onChange={handleChange}
          useFormik={false}
          placeholder={t('StartDate')}
        />
      </div>
      <div className='w-[200px]'>
        <DatePicker
          name='end_date'
          value={
            payloadData?.end_date
              ? moment(payloadData?.end_date, 'YYYY-MM-DD').toDate()
              : ''
          }
          onChange={handleChange}
          useFormik={false}
          placeholder={t('EndDate')}
        />
      </div>
      <div className='w-[200px]'>
        <TextInput
          useFormik={false}
          value={payloadData?.patient_file_number}
          onChange={e =>
            setPayloadData({
              ...payloadData,
              patient_file_number: e.target.value
            })
          }
          placeholder={t('MRN')}
        />
      </div>
      <div className='w-[200px]'>
        <TextInput
          useFormik={false}
          value={payloadData?.document_id}
          onChange={e =>
            setPayloadData({
              ...payloadData,
              document_id: e.target.value
            })
          }
          placeholder={t('Document ID')}
        />
      </div>

      <div className='flex gap-2 items-start flex-wrap'>
        <CustomButton
         // label={t('ApplyFilters')}
          title={t('ApplyFilters')}
          buttonType='primary'
          icon={'pi pi-filter'}
          className='w-fit h-[35px]'
          disabled={loading}
          onClick={handleApplyFilters}
        />
        <CustomButton
          //label={t('Reset')}
          title={t('Reset')}
          buttonType='reset'
          icon={'pi pi-sync'}
          disabled={loading}
          className='w-fit h-[35px]'
          onClick={handleResetFilters}
        />
        {/* {showBulkSubmit && (
          <CustomButton
            label={t('Bulk Submit')}
            icon='pi pi-send'
            buttonType='primary'
            className='w-fit h-[35px]'
            onClick={handleBulkSubmit}
          />
        )} */}
      </div>
    </div>
    <ReusableModal
      position='top'
      isVisible={showBulkSubmitModal}
      title={t('Bulk Submit Claims')}
      HeaderIcon={FiSend}
      onClose={() => setShowBulkSubmitModal(false)}
      className='w-full lg:w-[900px]'
    >
      <BulkSubmitClaimsModal
        onClose={() => setShowBulkSubmitModal(false)}
        onComplete={fetchNewData}
      />
    </ReusableModal>
    </>
  )
}

export default ClaimListFilters
